/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Row, Spin, Typography } from "antd";
import { SelectLoadMore } from "components/CustomSelect";
import { INPUT_TYPE } from "config/constants";

import styles from "./index.module.scss";
import { t } from "i18next";
import { useGetProducts } from "hooks/product/product";

function SelectProduct({ handleGetProduct, optionSelectProduct, isDisabledSelectProduct }) {
  const handleChange = (value, option) => {
    handleGetProduct && handleGetProduct({ ...option?.product });
  };
  const arrProductId = optionSelectProduct?.map((item) => item.id);

  const [params, setParams] = useState();
  const { data: productData, loading } = useGetProducts(params);
  useEffect(() => {
    setParams({
      filters: {
        query: "",
        ids: arrProductId,
      },
      pagination: {
        limit: 10,
        offset: 0,
      },
    });
  }, [optionSelectProduct]);

  const handleGetQuantityOrder = (id) => {
    return optionSelectProduct?.find((item) => item.id === id)?.quantityOrder;
  };

  const formatDataProduct = productData?.map((item) => ({
    code: item?.code,
    id: item?.id,
    name: item?.name,
    orderCode: optionSelectProduct && optionSelectProduct[0]?.orderCode,
    orderID: optionSelectProduct && optionSelectProduct[0]?.orderID,
    quantityOrder: handleGetQuantityOrder(item?.id),
  }));

  const handleSearchProduct = (value) => {
    setParams({
      filters: {
        query: value?.trim(),
        ids: arrProductId,
      },
      ...params?.pagination,
    });
  };
  const options = formatDataProduct?.map((item) => ({
    value: item.id,
    label: (
      <Row gutter={24}>
        <Col span={8}>
          <Typography.Link ellipsis strong style={{ padding: "5px 18px" }}>
            {item?.code}
          </Typography.Link>
        </Col>
        <Col span={16}>
          <Typography.Text ellipsis style={{ padding: "5px 18px" }}>
            {item?.name}
          </Typography.Text>
        </Col>
      </Row>
    ),
    product: item,
  }));
  return (
    <SelectLoadMore
      type={INPUT_TYPE.SELECT_LOAD_MORE}
      {...{
        inputOptions: {
          placeholder: t("warehouse.salesReturn.searchCodeProduct"),
          options: options,
          value: null,
          disabled: isDisabledSelectProduct,
          allowClear: false,
          dropdownRender: (originNode) => (
            <>
              <Row gutter={24} className={styles["custom-select"]}>
                <Col span={8}>
                  <Typography strong className={styles["header-select"]} style={{ padding: "12px 30px" }}>
                    {t("serialIE.productInfo.productCodeB")}
                  </Typography>
                </Col>
                <Col span={16}>
                  <Typography strong className={styles["header-select"]} style={{ padding: "12px 30px" }}>
                    {t("serialIE.productInfo.productNameB")}
                  </Typography>
                </Col>
              </Row>
              <Spin spinning={loading}>{originNode}</Spin>
            </>
          ),
          dropdownStyle: { zIndex: "1000" },
        },
      }}
      onSearch={(event) => handleSearchProduct(event)}
      onChange={handleChange}
    />
  );
}

export default SelectProduct;
